import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'edt-whatsapp-link-button',
  imports: [MatButtonModule, MatIconModule],
  template: `
    <button
      mat-stroked-button
      class="my-2 max-w-fit !text-[var(--mat-sys-on-primary)] !border-[var(--mat-sys-on-primary)]"
      (click)="helpLink.click()">
      @if (svgIcon()) {
        <mat-icon [svgIcon]="svgIcon()!"></mat-icon>
      }
      <span>{{ label() }}</span>
    </button>
    <a #helpLink target="_blank" class="hidden" [href]="url()"> link </a>
  `,
})
export class WhatsappLinkButtonComponent {
  phoneNumber = input.required<string>();
  message = input<string | null>(null);
  label = input('¿Necesitas ayuda?');
  svgIcon = input<string | null>('whatsapp');

  protected url = computed(() => {
    let message = `https://wa.me/${this.phoneNumber()}`;
    if (this.message()) message += `?text=${this.message()}`;
    return message;
  });
}
